export function useAnalytics() {
  const trackPurchase = (product) => {
    try {
      if (window.dataLayer && product) {
        /* eslint-disable-next-line */
        dataLayer.push({
          event: 'purchase',
          ecommerce: {
            detail: {
              products: {
                name: product.name,
                price: product.price,
                id: product.erp_id,
              },
            },
          },
        });
      }
    } catch (e) {
      console.warn('Error setting datalayer:', e);
    }
  };

  return {
    trackPurchase
  };
}
